export const isWeb: boolean = window.parent.__simulatorConfig__ !== undefined;
